import { timeOptions } from '../../options/options';
import { useFormContext } from 'react-hook-form';
import { ISpecialistListFilters } from '../../../../1_shared/config/interfaces';
import { SessionType } from '../../../../1_shared/config/interfaces/ISpecialistListFilters';
import changeParameterInRoute from '../../../../1_shared/helpers/changeParameterInRoute';
import { Location, useNavigate } from 'react-router';
import {
  IPriceFieldValue,
  ITimeFieldValue,
} from '../../ui/interfaces/IFilterFormProps';

// NOTE: хук для методов фильтров
const useFiltersMethods = (
  handleFieldChange: () => void,
  location: Location,
) => {
  const { setValue, getValues } = useFormContext<ISpecialistListFilters>();

  const navigate = useNavigate();

  const { localTimeFrom, localTimeTo } = getValues('slotsFilter') || {};

  const addParameterFilter = (value: [string, unknown][]) => {
    changeParameterInRoute(value, location, navigate);
  };

  const handlePriceChange = (value: IPriceFieldValue) => {
    setValue('minMoneyRate', value.min);
    setValue('maxMoneyRate', value.max);
    handleFieldChange();
  };

  const selectedOptionTime = () =>
    timeOptions.find(
      option =>
        option.value.start === localTimeFrom &&
        option.value.end === localTimeTo,
    );

  const handleOnlySupervisionChange = (value: boolean) => {
    setValue('sessionType', value ? SessionType.SUPERVISION : null);
    handleFieldChange();
  };

  const handleTimeChange = (value: ITimeFieldValue) => {
    setValue('slotsFilter.localTimeFrom', value.start || '');
    setValue('slotsFilter.localTimeTo', value.end || '');
    handleFieldChange();
  };

  return {
    handlePriceChange,
    selectedOptionTime,
    handleOnlySupervisionChange,
    handleTimeChange,
    addParameterFilter,
  };
};

export { useFiltersMethods };
